<template>
  <router-link to="/">
    <img :src="logo" alt="logo" />
  </router-link>
</template>

<script>
export default {
  data() {
    return {
      logo: require("../../../assets/img/logoLeftNew.png")
    };
  }
};
</script>

<style scoped>
img {
  max-width: 40px;
  float: left;
}
</style>
